import { Button } from '@material-ui/core'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'

const Upload = (props) => {
  const { open, handleClose, onSubmit, handleChange, change, loading } = props

  return (
    <DialogComponent
      open={open}
      handleclose={loading ? null : handleClose}
      title="Subir un archivo"
      children={
        <form>
          <input
            style={{ display: 'none' }}
            accept=".doc,.docx, .pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            id="contained-button-file"
            name="file"
            type="file"
            onChange={handleChange}
          />
          <label htmlFor="contained-button-file">
            {/* {change.name !== null && change.name !== undefined ? ( ver como generalizar */}
            {change !== null && change !== undefined ? (
              <Button
                color="primary"
                startIcon={<CheckCircleOutlineIcon />}
                variant="contained"
                fullWidth
                component="span"
                disabled={loading}
              >
                Archivo seleccionado
              </Button>
            ) : (
              <Button variant="contained" fullWidth component="span">
                Selecciona un archivo
              </Button>
            )}
          </label>
        </form>
      }
      actions={
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <CancelConfirmButtons
            onClickCancel={() => {
              handleClose()
            }}
            onClickSubmit={onSubmit}
            isLoading={loading}
            disabledCancel={loading}
            disabledSubmit={loading || change === null || change === undefined}
          />
        </div>
      }
    />
  )
}

export default Upload
